import React from "react";
import {OrbitComponent} from "../../../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {
    GamePlayPcHeaderBarAvailableVouchersListBox
} from "../../../boxes/free-play/game-vouchers-list/game-play-pc-header-bar-available-vouchers-list.box";
import {
    IFreePlayVoucherViewModel
} from "../../../../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardComponent} from "../../../../../../../free-play/parts/voucher-card/voucher-card.component";
import {
    GamePlayPcHeaderBarAvailableVouchersListTitleBox
} from "../../../boxes/free-play/game-vouchers-list/game-play-pc-header-bar-available-vouchers-list-title.box";

export const GamePlayPcHeaderBarAvailableVouchersListComponent = observer(
    class GamePlayPcHeaderBarAvailableVouchersListComponent extends OrbitComponent<{gameContext: IGameContextViewModel, onVoucherClick: (voucher: IFreePlayVoucherViewModel) => void}> {

        private _onVoucherClick = (voucher: IFreePlayVoucherViewModel) => {
            this.props.onVoucherClick(voucher);
        }

        render() {
            const availableVouchers = this.props.gameContext.freePlayContext.otherAvailableVouchersForCurrentGame;
            if(availableVouchers.length === 0) {
                return null;
            }
            return (
                <GamePlayPcHeaderBarAvailableVouchersListBox className={'cy-free-play-vouchers-container'}>
                    <GamePlayPcHeaderBarAvailableVouchersListTitleBox>
                        {this.services.translation.translate('FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE')}
                    </GamePlayPcHeaderBarAvailableVouchersListTitleBox>
                    {availableVouchers.map(v => <VoucherCardComponent key={v.id} voucher={v} onClick={this._onVoucherClick}/>)}
                </GamePlayPcHeaderBarAvailableVouchersListBox>
            )
        }
    }
);